import routerOptions0 from "/app/app/router.options.ts";
import routerOptions1 from "/app/node_modules/.pnpm/nuxt@3.8.1_@unocss+reset@0.58.8_axios@1.6.2_eslint@8.53.0_floating-vue@5.2.2_sass@1.69.5_styl_av2kow6adt6dgptqo7m6t4jqtq/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}